(function(){
  "use strict";
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var MONEY = (window.GENIX && window.GENIX.moneyFormat) || "R{{amount}}";

  function formatMoney(cents){
    var value = (cents/100);
    function num(n,dec,thou){ n=(n||0).toFixed(dec); var p=n.split("."); var i=p[0].replace(/\B(?=(\d{3})+(?!\d))/g,thou||","); return dec?i+"."+p[1]:i; }
    return MONEY.replace(/\{\{\s*(\w+)\s*\}\}/g,function(m,key){
      switch(key){
        case "amount": return num(value,2,",");
        case "amount_no_decimals": return num(value,0,",");
        case "amount_with_comma_separator": return num(value,2,".").replace(/,/g,"X").replace(/\./g,",").replace(/X/g,".");
        case "amount_no_decimals_with_comma_separator": return num(value,0,".");
        default: return num(value,2,",");
      }
    });
  }

  var GVIAL='<svg viewBox="0 0 100 130" fill="none"><rect x="26" y="40" width="48" height="72" rx="7" fill="#F4F6F5" stroke="#D7DAD8" stroke-width="1.2"/><ellipse cx="50" cy="98" rx="22" ry="7" fill="#EFEAE0"/><rect x="41" y="18" width="18" height="12" rx="2" fill="#C7CBCD" stroke="#AFB4B6" stroke-width="1"/><ellipse cx="50" cy="18" rx="11" ry="4" fill="#1C6B5E"/><rect x="32" y="60" width="36" height="30" rx="3" fill="#fff" stroke="#E4E4DE"/></svg>';

  /* ---------- reveal ---------- */
  function initReveal(){
    var els=document.querySelectorAll(".reveal");
    if(reduce || !("IntersectionObserver" in window)){ els.forEach(function(e){e.classList.add("in");}); return; }
    var io=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){e.target.classList.add("in");io.unobserve(e.target);}});},{threshold:.12,rootMargin:"0px 0px -6% 0px"});
    els.forEach(function(e){io.observe(e);});
  }

  /* ---------- nav ---------- */
  var nav=document.getElementById("nav");
  window.addEventListener("scroll",function(){ if(nav) nav.classList.toggle("scrolled",(window.scrollY||0)>8); },{passive:true});
  var mt=document.getElementById("menu-t"), mm=document.getElementById("mobile-menu");
  if(mt){ mt.addEventListener("click",function(){ mm.classList.toggle("open"); }); }

  /* ---------- gate ---------- */
  var gate=document.getElementById("gate");
  try{ if(sessionStorage.getItem("genixlabs-gate")==="1"){gate.classList.add("hide");}else{document.body.classList.add("locked");} }
  catch(e){ document.body.classList.add("locked"); }
  var ga=document.getElementById("gate-agree");
  if(ga){ga.addEventListener("click",function(){gate.classList.add("hide");document.body.classList.remove("locked");try{sessionStorage.setItem("genixlabs-gate","1");}catch(e){}});}

  /* ---------- count ---------- */
  function setCount(n){ var el=document.getElementById("cart-count"); if(el){ el.textContent=n; el.style.display=n>0?"grid":"none"; } }

  /* ---------- drawer ---------- */
  var drawer=document.getElementById("drawer"), dbd=document.getElementById("dbd");
  function openDrawer(){ renderDrawer(); drawer.classList.add("open"); dbd.classList.add("open"); }
  function closeDrawer(){ drawer.classList.remove("open"); dbd.classList.remove("open"); }
  function renderDrawer(){
    fetch("/cart.js",{headers:{"Accept":"application/json"}}).then(function(r){return r.json();}).then(function(cart){
      setCount(cart.item_count);
      var body=document.getElementById("drawer-body"), f=document.getElementById("drawer-f");
      if(cart.item_count===0){ body.innerHTML='<div class="drawer-empty">Your cart is empty.</div>'; f.innerHTML=''; return; }
      body.innerHTML=cart.items.map(function(it,i){
        var img=it.image?('<img class="imgfill" src="'+it.image.replace(/(\.[a-zA-Z]+)(\?|$)/,'_120x$1$2')+'" alt="">'):GVIAL;
        var opt=(it.variant_title && it.variant_title!=="Default Title")?it.variant_title:"";
        return '<div class="drawer-item"><a class="di-img" href="'+it.url+'"><div class="vialwrap">'+img+'</div></a>'
          +'<div><h4><a href="'+it.url+'">'+it.product_title+'</a></h4>'+(opt?'<div class="m">'+opt+'</div>':'')
          +'<div class="qty"><button type="button" data-cline="'+(i+1)+'" data-cqty="'+(it.quantity-1)+'">&minus;</button><span>'+it.quantity+'</span><button type="button" data-cline="'+(i+1)+'" data-cqty="'+(it.quantity+1)+'">+</button></div></div>'
          +'<div class="di-right"><div class="di-price">'+formatMoney(it.final_line_price)+'</div><button class="rm" type="button" data-cline="'+(i+1)+'" data-cqty="0">Remove</button></div></div>';
      }).join("");
      f.innerHTML='<div class="row total"><span>Subtotal</span><span class="mono">'+formatMoney(cart.total_price)+'</span></div>'
        +'<a class="btn btn-dark full" href="/checkout">Checkout</a>'
        +'<a class="btn btn-line full" href="/cart" style="margin-top:8px">View cart</a>'
        +'<p class="drawer-note">'+(cart.total_price>=150000?"You qualify for free courier.":"Free courier over R1,500.")+'</p>';
    });
  }
  function changeLine(line,qty){
    fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify({line:line,quantity:qty})})
      .then(function(r){return r.json();}).then(function(cart){ setCount(cart.item_count); renderDrawer(); });
  }
  document.getElementById("drawer-body").addEventListener("click",function(e){
    var b=e.target.closest&&e.target.closest("[data-cline]");
    if(b){ changeLine(parseInt(b.getAttribute("data-cline"),10),parseInt(b.getAttribute("data-cqty"),10)); }
  });
  var cartBtn=document.getElementById("cart-btn");
  if(cartBtn){ cartBtn.addEventListener("click",function(e){ e.preventDefault(); openDrawer(); }); }
  document.getElementById("drawer-close").addEventListener("click",closeDrawer);
  dbd.addEventListener("click",closeDrawer);

  function addItem(id,qty){
    return fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify({id:id,quantity:qty})})
      .then(function(r){return r.json();}).then(function(){ openDrawer(); });
  }

  /* ---------- product page ---------- */
  function initPDP(){
    var pdp=document.getElementById("pdp"); if(!pdp) return;
    var opts=document.getElementById("opts");
    if(opts){ opts.addEventListener("click",function(e){
      var b=e.target.closest("[data-vid]"); if(!b||b.disabled) return;
      opts.querySelectorAll("button").forEach(function(x){x.classList.remove("on");}); b.classList.add("on");
      document.getElementById("variant-id").value=b.getAttribute("data-vid");
      document.getElementById("pdp-price").textContent=b.getAttribute("data-price");
      var was=document.getElementById("pdp-was"); if(was) was.textContent=b.getAttribute("data-compare")||"";
      var save=document.getElementById("pdp-save"); if(save){ var s=b.getAttribute("data-save"); if(s){save.textContent="Save "+s+"%";save.style.display="";}else{save.style.display="none";} }
      var bb=document.getElementById("bb-price"); if(bb) bb.textContent=b.getAttribute("data-price");
    }); }
    pdp.addEventListener("click",function(e){
      var q=e.target.closest("[data-q]");
      if(q){ var d=parseInt(q.getAttribute("data-q"),10); var qv=document.getElementById("qv"); var n=Math.max(1,parseInt(qv.textContent,10)+d); qv.textContent=n; document.getElementById("qv-input").value=n; return; }
      var tab=e.target.closest("[data-tab]");
      if(tab){ var name=tab.getAttribute("data-tab"); tab.parentElement.querySelectorAll("button").forEach(function(x){x.classList.remove("on");}); tab.classList.add("on");
        document.querySelectorAll("[data-panel]").forEach(function(pn){ pn.hidden = pn.getAttribute("data-panel")!==name; }); return; }
    });
    var form=document.getElementById("product-form");
    if(form){ form.addEventListener("submit",function(e){ e.preventDefault();
      var id=document.getElementById("variant-id").value; var qty=parseInt(document.getElementById("qv-input").value,10)||1;
      addItem(id,qty);
    }); }
    var bb=document.getElementById("bb-add");
    if(bb){ bb.addEventListener("click",function(){ if(form) form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event("submit",{cancelable:true})); }); }
  }

  /* ---------- quick add on cards ---------- */
  document.addEventListener("click",function(e){
    var a=e.target.closest&&e.target.closest("[data-add]");
    if(a){ e.preventDefault(); addItem(parseInt(a.getAttribute("data-add"),10),1); }
  });

  /* ---------- search ---------- */
  var sov=document.getElementById("search-ov"), sin=document.getElementById("search-input"), sres=document.getElementById("search-res"), shint=document.getElementById("search-hint");
  function openSearch(){ sov.classList.add("open"); document.body.classList.add("locked"); setTimeout(function(){sin.focus();},80); }
  function closeSearch(){ sov.classList.remove("open"); document.body.classList.remove("locked"); sin.value=""; sres.innerHTML=""; shint.style.display="block"; }
  var stimer;
  function runSearch(){
    var q=sin.value.trim();
    if(!q){ sres.innerHTML=""; shint.style.display="block"; return; }
    shint.style.display="none";
    fetch("/search/suggest.json?q="+encodeURIComponent(q)+"&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last")
      .then(function(r){return r.json();}).then(function(data){
        var items=(data.resources&&data.resources.results&&data.resources.results.products)||[];
        if(items.length===0){ sres.innerHTML='<div class="search-empty">No compounds match "'+q+'".</div>'; return; }
        sres.innerHTML=items.map(function(p){
          var img=p.image?('<img class="imgfill" src="'+p.image+'" alt="">'):GVIAL;
          return '<a href="'+p.url+'"><div class="si"><div class="vialwrap">'+img+'</div></div><div><h4>'+p.title+'</h4><div class="m">'+(p.type||"Research compound")+'</div></div><div class="pr">'+(p.price||"")+'</div></a>';
        }).join("");
      }).catch(function(){ sres.innerHTML='<div class="search-empty">Search is unavailable right now.</div>'; });
  }
  var sbtn=document.getElementById("search-btn");
  if(sbtn){ sbtn.addEventListener("click",openSearch); }
  document.getElementById("search-close").addEventListener("click",closeSearch);
  sin.addEventListener("input",function(){ clearTimeout(stimer); stimer=setTimeout(runSearch,180); });
  sres.addEventListener("click",function(e){ if(e.target.closest("a")){ closeSearch(); } });
  document.addEventListener("keydown",function(e){ if(e.key==="Escape"){ if(sov.classList.contains("open"))closeSearch(); if(drawer.classList.contains("open"))closeDrawer(); } });

  /* ---------- init ---------- */
  function init(){ initReveal(); initPDP(); setCount((window.GENIX&&window.GENIX.cartCount)||0); }
  if(document.readyState!=="loading"){ init(); } else { document.addEventListener("DOMContentLoaded",init); }
})();
